import playAudio from "../../../../assets/volume-max.svg";
import CloseIcon from "../../../../assets/closeIcon.svg";
import { Handle } from "@xyflow/react";
import { IconButton } from "@mui/material";
import RightArrow from "../../../../assets/arrow-right.svg";

export default function PlayAudioActionNode({ data, selected, id}) {
	const header = data.digit === "trigger" ? data.action : data.action === "Play Audio" ? `${data.digit} - Play Audio` : "Play Audio";
	
	return (
        <div style={{ position: "relative" }}>
          <div style={{
            display: "inline-block",
            borderRadius: 8,
            padding: selected ? 4 : 0,
            boxShadow: (data.showInvalid && data.invalid) ? "0 0 0 0 #fff" : selected ? "0px 0px 3.01px 3.01px #34CB65, 0px 0px 0px 1.5px #FFFFFF" : "0 0 0 0 #fff",
            border: (data.showInvalid && data.invalid) ? "1.5px solid #F44336" : "none",
            transition: "box-shadow 0.3s, padding 0.3s,  border 0.3s",
            backgroundColor: "transparent"
		      }}>
            <div style={{ ...localStyles.container, display: "flex", flexDirection: "column" }}>
              <div style={{ backgroundColor: "#FFA500", height: "6px", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }} />
              <div style={{ display: "flex", alignItems: "center", padding: 12, gap: 6 }}>
                <div style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#F8E9FE", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <img src={playAudio} alt="Play Audio" style={localStyles.img} />
                </div>
                <div className="t7 nc-gray-900 medium-font" style={{textDecoration: selected ? "underline" : "none"}}>{header}</div>
              </div>
              <div style={{ padding: "12px", borderTop: "1px solid #E0E0E0" }}>
                Play Audio
			  	      <img src={RightArrow} alt="Right Arrow" style={{ margin: "0 4px", width: "12px", height: "12px" }} />
				        {(data.audio??{}).file? data.audio.file.name : ""}
              </div>
            </div>
            <Handle type="target" position="top" style={localStyles.handle} />
            <Handle type="source" position="bottom" style={localStyles.handle} />
          </div>
          <IconButton disabled={!selected} onClick={data.onDelete} style={{ position: "absolute", top: 20, right: 0 }}>
            <img src={CloseIcon} alt="Close" style={{ width: "16px", height: "16px" }} />
          </IconButton>
        </div>
      );
}

const nodeDimensions = { width: "352px" };
const localStyles = {
	img: {
		width: 16,
		height: 16,
	},
	container: {
		width: nodeDimensions.width,
		border: "1px solid #E0E0E0",
		borderRadius: 8,
		backgroundColor: "#fff"
	},
	handle: {
		background: "#555" },
}